import React from 'react';

function LandingPage() {
  return (
      <>
        <p>
          React version {React.version}</p>
      </>
  );
}

export default LandingPage;
